export default (vm) => {
    let validationResult = true
    // validation functions
    let validateIpAddress = (value) => {
        return (/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(value) || value === 'NULL')
    }
    let validateServerAddress = (value) => {
        return (/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(value) || /(\w+\.\w*\.?)+/.test(value) || value === 'NULL')
    }
    let validateServerPort = (value) => {
        return ((/^[0-9]+$/.test(value) && (parseInt(value) > 0 && parseInt(value) < 65536)) || value === 'NULL')
    }
    let validateTokenTime = (value) => {
        return ((/^[0-9]+$/.test(value) && (parseInt(value) > 0 && parseInt(value) < 1441)) || value === 'NULL')
    }
    let validateDatabaseSize = (value) => {
        return ((/^[0-9]+$/.test(value) && (parseInt(value) > 0 && parseInt(value) < 10241)) || value === 'NULL')
    }
    let validateInteger = (value) => {
        return /^\d+$/.test(value)
    }
    let validateQueryName = (value) => {
        return /^[A-Za-z0-9]{1,8}$/.test(value)
    }
    let validateTagName = (value) => {
        return /^[a-zA-Z]{1}[a-zA-Z0-9]{0,14}$/.test(value)
    }
    let validateNonEmpty = (value) => {
        return value.length > 0
    }
    let validateIntegerRange = (value, minRange, maxRange) => {
        return /^[0-9]+$/.test(value) && (parseInt(value) > minRange && parseInt(value) < maxRange)
    }

    // check register type
    let getRegisterType = (functionCode) => {
        if(functionCode === '1' || functionCode === '2' || functionCode === '5') {
            return 'digital'
        } else if(functionCode === '3' || functionCode === '4' || functionCode === '6') {
            return 'analog'
        }
    }

    // compute max tag offset value
    let getMaxTagOffsetValue = (registerType, numberOfRegisters, tagAddressLength) => {
        if(registerType === 'digital') {
            return numberOfRegisters - tagAddressLength
        } else if(registerType === 'analog') {
            return (numberOfRegisters * 2) - tagAddressLength
        }
    }

    // compute tag address length
    let getTagAddressLength = (tagDatatype) => {
        if(tagDatatype === '1') {
            return '1'
        } else if(tagDatatype === '2' || tagDatatype === '3' || tagDatatype === '11') {
            return '2'
        } else if(tagDatatype === '4' || tagDatatype === '5' || tagDatatype === '6' || tagDatatype === '8' || tagDatatype === '9' || tagDatatype === '10' || tagDatatype === '12' || tagDatatype === '13') {
            return '4'
        } else if(tagDatatype === '7' || tagDatatype === '14') {
            return '8'
        }
    }

    // validate server-form section
    if(vm.loggingMethod === 'ftp' || vm.loggingMethod === 'http') {
        vm.serverData[vm.loggingMethod].serverArr.forEach((serverObj) => {
            if((!validateServerAddress(serverObj.serverAddress)) || (!validateServerAddress(serverObj.ftpserverAddress))) {
                alert('Server Address format error in Server Details section')
                validationResult = false
            }
            if((!validateServerPort(serverObj.portNumber)) || (!validateServerPort(serverObj.ftpportNumber))) {
                alert('Server port format error in Server Details section')
                validationResult = false
            }
        })
    } else if(vm.loggingMethod === 'cumulocity') {
        if(!validateIpAddress(vm.serverData.cumulocity.ftpServerAddress)) {
            alert('Server Address format error in Server Details section')
            validationResult = false
        }
        if(!validateServerPort(vm.serverData.cumulocity.ftpPortNumber)) {
            alert('Server port format error in Server Details section')
            validationResult = false
        }
    } else if(vm.loggingMethod === 'mqtt') {
        if((!validateIpAddress(vm.serverData.mqtt.hostname)) || (!validateIpAddress(vm.serverData.mqtt.ftpServerAddress))) {
            alert('Server Address format error in Server Details section')
            validationResult = false
        }
        if((!validateServerPort(vm.serverData.mqtt.portNumber)) || (!validateServerPort(vm.serverData.mqtt.ftpPortNumber))) {
            alert('Server port format error in Server Details section')
            validationResult = false
        }
    } else if(vm.loggingMethod === 'azure') {
        if(!validateIpAddress(vm.serverData.azure.ftpServerAddress)) {
            alert('Server Address format error in Server Details section')
            validationResult = false
        }
        if((!validateServerPort(vm.serverData.azure.portNumber)) || (!validateServerPort(vm.serverData.azure.ftpPortNumber))) {
            alert('Server port format error in Server Details section')
            validationResult = false
        }
        if(!validateTokenTime(vm.serverData.azure.tokentime)) {
            alert('Server token time format error in Server Details section')
            validationResult = false
        }
    }
    //validate Logger Details
    if(!validateDatabaseSize(vm.loggerData.databaseSize)) {
        alert('Database size format error in Server Details section')
        validationResult = false
    }
    // validate polling-group section
    vm.modbusConfig.pollingGroupArr.forEach((pollingGroupObj) => {
        if(!validateInteger(pollingGroupObj.pollingInterval)) {
            alert('Polling Interval format error')
            validationResult = false
        }

        // iterate through query fields
        pollingGroupObj.queryArr.forEach((queryObj) => {
            // validate Query Name
            if(!validateQueryName(queryObj.queryName)) {
                alert('Query name format error')
                validationResult = false
            }

            // validate Slave ID
            if(!validateIntegerRange(queryObj.slaveId, 0, 248)) {
                alert('Slave ID format error')
                validationResult = false
            }

            // validate function code
            if(!validateNonEmpty(queryObj.functionCode)) {
                alert('Function code cannot be empty')
                validationResult = false
            }

            // validate start Address
            if(!validateIntegerRange(queryObj.startAddress, -1, 65536)) {
                alert('Start address format error')
                validationResult = false
            }

            // validate number of registers
            if(!validateIntegerRange(queryObj.numberOfRegisters, 0, 65536)) {
                alert('Number of Registers format error')
                validationResult = false
            }

            // validate IP address
            if(!validateIpAddress(queryObj.ipAddress)) {
                alert('IP address format error')
                validationResult = false
            }

            // validate port number
            if(!validateServerPort(queryObj.port)) {
                alert('Port number format error')
                validationResult = false
            }

            // set register type of query
            let registerType = getRegisterType(queryObj.functionCode)

            // iterate through Tags
            queryObj.tagArr.forEach((tagObj) => {
                // set tagAddressLength
                let tagAddressLength = getTagAddressLength(tagObj.tagDatatype)

                // set max tag offset value
                let maxTagOffsetValue = getMaxTagOffsetValue(registerType, queryObj.numberOfRegisters, tagAddressLength)

                // validate Tag Name
                if(!validateTagName(tagObj.tagName)) {
                    alert('Tag Name format error')
                    validationResult = false
                }

                // validate tag address offset
                if(!validateIntegerRange(tagObj.tagAddressOffset, -1, maxTagOffsetValue + 1)) {
                    alert('Tag address offset out of range')
                    validationResult = false
                }

                // validate tag data type
                if(!validateNonEmpty(tagObj.tagDatatype)) {
                    alert('Tag data type cannot be empty')
                    validationResult = false
                }

                // validate alert flag
                if(!validateNonEmpty(tagObj.tagAlertFlag)) {
                    alert('Tag alert flag cannot be empty')
                    validationResult = false
                }
            })
        })
    })

    // iterate through upload groups
    vm.modbusConfig.uploadGroupArr.forEach((uploadGroupObj) => {
        if(!validateInteger(uploadGroupObj.uploadInterval)) {
            alert('Upload interval cannot be blank')
            validationResult = false
        }
    })
    // return validation result
    return validationResult
}



// WEBPACK FOOTER //
// ./src/validate-form/validateForm.js